// 导入所有 partner 模块的国际化文件
import { messages as transferPartnerGoodsMessages } from '@/lang/partner/transferPartnerGoodsLang.js'
import { messages as deletePartnerGoodsMessages } from '@/lang/partner/deletePartnerGoodsLang.js'
import { messages as partnerGoodsMessages } from '@/lang/partner/partnerGoodsLang.js'
import { messages as partnerMessages } from '@/lang/partner/partnerLang.js'
import { messages as partnerLogMessages } from '@/lang/partner/partnerLogLang.js'
import { messages as partnerOrdersMessages } from '@/lang/partner/partnerOrdersLang.js'
import { messages as syncPartnerGoodsPriceMessages } from '@/lang/partner/syncPartnerGoodsPriceLang.js'
import { messages as syncPartnerGoodsStockMessages } from '@/lang/partner/syncPartnerGoodsStockLang.js'

// 合并所有国际化消息
export const messages = {
    en: {
        ...transferPartnerGoodsMessages.en,
        ...deletePartnerGoodsMessages.en,
        ...partnerGoodsMessages.en,
        ...partnerMessages.en,
        ...partnerLogMessages.en,
        ...partnerOrdersMessages.en,
        ...syncPartnerGoodsPriceMessages.en,
        ...syncPartnerGoodsStockMessages.en
    },
    zh: {
        ...transferPartnerGoodsMessages.zh,
        ...deletePartnerGoodsMessages.zh,
        ...partnerGoodsMessages.zh,
        ...partnerMessages.zh,
        ...partnerLogMessages.zh,
        ...partnerOrdersMessages.zh,
        ...syncPartnerGoodsPriceMessages.zh,
        ...syncPartnerGoodsStockMessages.zh
    }
} 